export var FaireDirectWidgetIA = function FaireDirectWidgetIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return FAIRE_DIRECT_WIDGET_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [FAIRE_DIRECT_WIDGET_DESCRIPTION(strictLocalize)];
    }
  };
};
var FAIRE_DIRECT_WIDGET_TITLE = function FAIRE_DIRECT_WIDGET_TITLE(strictLocalize) {
  return strictLocalize({
    id: "EU/ffT",
    defaultMessage: "Let’s help you install the widget"
  });
};
var FAIRE_DIRECT_WIDGET_DESCRIPTION = function FAIRE_DIRECT_WIDGET_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "zSYy0U",
    defaultMessage: "Our support team will be happy to help. Chat with an agent or check out the related articles below."
  });
};